import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const CompetitorRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border-soft);
  padding: 12px 8px 12px 12px;

  &:not(:last-child) {
    border-bottom: none;
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:hover {
    cursor: pointer;
    background-color: var(--surface-hover);
  }
`;

export const CompetitorNameWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  ${typographyV2.bodySm};
`;

export const CompetitorName = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const LoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '230px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const TitleLabel = styled.div`
  ${typographyV2.bodySm};
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
